import React from 'react'
import type { Icon } from 'shared/utils'

const PreOrder = (props: Icon) => {
    const { color = 'black', size = 24, className = 'pre-order' } = props
    return (
        <svg
            className={className}
            width={size}
            height={size}
            fill={color}
            viewBox="0 0 24 24">
            <path
                fillRule="evenodd"
                d="M16.5 2h-8C7.12 2 6 3.018 6 4.273v15.454C6 20.982 7.12 22 8.5 22h8c1.38 0 2.5-1.018 2.5-2.273V4.273C19 3.018 17.88 2 16.5 2zm-4 19.09c-.83 0-1.5-.608-1.5-1.363 0-.754.67-1.363 1.5-1.363s1.5.609 1.5 1.363c0 .755-.67 1.364-1.5 1.364zm4.5-3.635H8V4.727h9v12.728z"
            />
        </svg>
    )
}

export { PreOrder }
